module.exports = __webpack_public_path__ + "fonts/TheSansVeolia-W6SeBld.9f1855f8.otf";